/* Full-page views that provide their own chrome (header, background) and must
   render outside every layout wrapper (ShellV2 Layout and the legacy
   DashboardLayout). */
const STANDALONE_PATHS = ["/communities", "/communities/simulator", "/communities/admin"];

// eslint-disable-next-line import/prefer-default-export
export const isStandalonePath = (pathname) =>
  STANDALONE_PATHS.includes(pathname.replace(/\/+$/, "") || "/");
